import React, { useState, useEffect } from "react";
import { fetchMedicalSchemesByName } from "../../medPracapi";
import Form from "react-bootstrap/Form";

function SchemeSearch({ onSchemeCodeSelect, category, value = "" }) {
  const [searchQuery, setSearchQuery] = useState(value || "");
  const [filteredResults, setFilteredResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isOptionSelected, setIsOptionSelected] = useState(false);

  // ✅ Sync parent-provided value into the input (edit-mode prefill)
  useEffect(() => {
    const next = value || "";
    setSearchQuery(next);

    // if parent sets a value, treat it as selected
    if (next) {
      setIsOptionSelected(true);
      setShowDropdown(false);
      setFilteredResults([]);
    } else {
      setIsOptionSelected(false);
    }
  }, [value]);

  useEffect(() => {
    if (searchQuery.length < 3 || isOptionSelected) {
      setFilteredResults([]);
      setShowDropdown(false);
      return;
    }

    const fetchSchemes = async () => {
      setLoading(true);
      const data = await fetchMedicalSchemesByName(searchQuery, category);
      setFilteredResults(data);
      setLoading(false);
      setShowDropdown(data.length > 0);
    };

    const delayDebounce = setTimeout(() => {
      fetchSchemes();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery, isOptionSelected, category]); // ✅ include category

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setIsOptionSelected(false);
  };

  const handleSchemeClick = (scheme) => {
    setSearchQuery(scheme.name);
    onSchemeCodeSelect(scheme);
    setShowDropdown(false);
    setIsOptionSelected(true);
  };

  return (
    <div style={{ position: "relative" }}>
      <Form.Control
        type="text"
        placeholder="Search medical aid..."
        value={searchQuery}
        onChange={handleSearchChange}
        className="mb-3"
        autoComplete="off"
      />

      {loading && <p>Loading...</p>}

      {showDropdown && (
        <div
          className="results-box"
          style={{
            position: "absolute",
            zIndex: 10,
            backgroundColor: "white",
            border: "1px solid #ccc",
            width: "100%",
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {filteredResults.map((scheme) => (
            <div
              key={scheme.code}
              className="result-item"
              onClick={() => handleSchemeClick(scheme)}
              style={{
                cursor: "pointer",
                padding: "8px",
                borderBottom: "1px solid #eee",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "white";
              }}
            >
              {scheme.code} - {scheme.name}
            </div>
          ))}
        </div>
      )}

      {searchQuery.length >= 3 &&
        !loading &&
        filteredResults.length === 0 &&
        !isOptionSelected && <p>No results found.</p>}
    </div>
  );
}

export default SchemeSearch;
